<template>
  <div
    id="header_azour"
    :class="`header`"
    :style="viewType ? headerAzour : ''"
  >
    <div class="header_content">
      <h1 :class="`brand`">{{ restaurant.name }}</h1>
      <span
        :class="`brand-text`"
        v-text="newItem[currentLang] ? newItem[currentLang].name : ''"
        >{{ name }}</span
      >
      <span :class="`onomo`"></span>
      <span :class="`onomo-text`">{{
        restaurant.observation
      }}</span>
      <div :class="`header_bottom`">
        <!-- <span  id="section01" class="header_click" data-id="body"><span class="header_click" data-id="body"></span>Scroll</span> -->
        <!-- <div
          :class="`scroll-down header_click `"
          data-id="body"
        ></div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { apiPath1 } from "../../../../../../constants/config";
export default {
  props: [
    "restaurant",
    "smaler",
    "changeName",
    "currentLang",
    "newItem",
    "viewType"
  ],
  computed: {
    headerAzour: function() {
      return {
        width: "100% !important",
        height: "80vh  !important",
        "max-width": "unset !important"
      };
    }
  },
  data() {
    return {
      // apiPath1: apiPath1,
      name: "name of the menu"
    };
  },
  watch: {
    name(newVal) {
      this.changeName(newVal);
    }
  }
};
</script>

<style >
#header_azour.header {
  width: calc(100% - 24px);
  max-width: 780px;
  background-color: black;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  background-image: url(htttp://localhost:3333/azour/img/background.jpg);
  padding: 12px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
}

#header_azour.smaler {
  height: 200px;
  max-width: unset;
  width: 100%;
}
#header_azour .header_content {
  width: 100%;

  background-color: black;
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

#header_azour .brand {
  color: #e6a0da;
  font-size: 70px;
  font-family: sans-serif;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 12px;
  /* font-family: 'Major Mono Display', monospace; */
  font-family: "Major Mono Display", monospace;
}
#header_azour .brand.smaler {
  font-size: 18px;
  margin-bottom: 6px;
}
#header_azour .brand-text.smaler {
  letter-spacing: 2px;
  font-size: 12px;
}
#header_azour .brand-text {
  color: #fff;
  letter-spacing: 4px;
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 12px;
}
#header_azour .onomo.smaler {
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 6px;
}
#header_azour .onomo {
  color: orange;
  font-weight: bolder;
  font-size: 30px;
  text-transform: uppercase;
  margin-bottom: 12px;
}
#header_azour .onomo-text.smaler {
  letter-spacing: 1px;
  font-size: 10px;
  font-weight: 100px;
  margin-bottom: 12px;

}
#header_azour .onomo-text {
  color: orange;
  text-transform: uppercase;
  letter-spacing: 3px;
     font-size: 12px;
    font-weight: 100px;
    margin-bottom: 36px;
    max-width: 590px;
    text-align: center;
}
@media screen and (max-width:580px) {
  #header_azour .onomo-text{
    max-width: unset !important;
    padding: 0 20px !important;
  }
  #header_azour .brand-text{
    font-size: 16px;
  }
  #header_azour .brand{
    font-size: 45px;
  }
}
</style>
